<template>
  <div>
    <user-warning-message v-if="detail" :users="warningMessages"/>
    <contact-warning-message v-if="detail" :contacts="intervenantsWithArchivedContact"
      class="mgt-20px"/>
    <information-general :plan-media="planMedia" :detail="detail"/>
    <recapitulatif-montant :recapitulatifMontant="recapitulatifMontant" class="mgt-20px">
    </recapitulatif-montant>
    <div class="card mgt-20px">
      <header class="header-card">
        <p>{{ $t('addEditPlanMedia.intervenant.title')}}</p>
      </header>
      <div class="card-content">
        <selection-client
          v-if="!detail"
          :isMultiContact="false"
          :nouveauDevisCommande="planMedia"
          :gestion-echeancier="false"
          :typeAjoutClientComplet="constantes.PLAN_MEDIA"/>
        <intervenants
          v-else
          :intervenants="planMedia.intervenants"/>
      </div>
    </div>
    <div class="card mgt-20px">
      <header class="header-card">
        <p>{{ $t('addEditPlanMedia.piecesJointes.title')}}</p>
      </header>
      <div class="card-content">
        <pieces-jointes
          :checkPermissions="true"
          :read-only="detail"/>
      </div>
    </div>
  </div>
</template>

<script>
import InformationGeneral from '@/components/planMedia/edition/informationGeneral';
import Intervenants from '@/components/planMedia/detail/l_intervenants';
import SelectionClient from '@/components/devisCommandes/editionDevisCommande/selectionClients';
import PiecesJointes from '@/components/general/piecesJointes';
import RecapitulatifMontant from '@/components/planMedia/recapitulatifMontant';
import userWarningMessage from '@/components/commun/user/userWarningMessage';
import { PLAN_MEDIA } from '@/configuration/bodac/planMedia/planMediaConfig';
import contactWarningMessage from '@/components/commun/tiers/contact/contactWarningMessage';
import getIntervenantsWithArchivedContact from '@/services/contact/getIntervenantsWithArchivedContact';

export default {
  props: {
    planMedia: {
      type: Object,
      required: true,
    },
    detail: {
      type: Boolean,
    },
    recapitulatifMontant: {
      type: Object,
      required: false,
    },
  },
  components: {
    RecapitulatifMontant,
    InformationGeneral,
    SelectionClient,
    Intervenants,
    PiecesJointes,
    userWarningMessage,
    contactWarningMessage,
  },
  data() {
    return {
      constantes: {
        PLAN_MEDIA,
      },
    };
  },
  computed: {
    warningMessages() {
      return [
        {
          id: this.planMedia.commercialId,
          msg: 'utilisateur.warning.assistantArchive',
        },
        ...this.planMedia.evenements.map(e => ({
          id: e.commercialId,
          msg: 'utilisateur.warning.commercialArchive',
        })),
        ...this.planMedia.commissions.map(c => ({
          id: c.commercialId,
          msg: 'utilisateur.warning.commercialArchive',
        })),
      ];
    },
    intervenantsWithArchivedContact() {
      return getIntervenantsWithArchivedContact(this.planMedia.intervenants);
    },
  },
};
</script>
